<template>
  <modal :show.sync="showModal" id="updateallvalues" size="lg" @close="closeModalWithoutSaving">
    <template slot="header">
      <h5 class="modal-title" id="exampleModalLabel">
        Atualizar Informações da Marca
      </h5>
    </template>
    <validation-observer ref="formValidator">
      <form role="form">
        <div class="row">
          <div class="col-md-4">
            <base-input 
              type="date" 
              label="Pagamento do Fornecedor" 
              v-model="commercialBrandHandler.payment_date" 
              rules="required"
            />
            
          </div>
          <div class="col-md-4">
            <base-input 
              type="date" 
              label="Custo de Compra Calc" 
              v-model="commercialBrandHandler.purchase_cost_date" 
              rules="required"
            />
            
          </div>
          <div class="col-md-4">
            <base-input
              placeholder="Margem de Lucro da Vegetal"
              v-model="commercialBrandHandler.gain_margin"
              group class="mb-3"
              label="Margem de Lucro da Vegetal"
              append-icon="fa fa-percent"
              mask="volume"
              rules="required"
            />
          
          </div>
          <div class="col-md-12 align-self-md-center mb-4"><span><strong>Valores padrões Marcas</strong></span></div>
          <div class="col-md-12 div-striped mb-3" style="max-height: 100px;" v-for="(addition, index) in additions" :key="addition.tabe_cta">
            <div class=" row">
              <div class="col-md-6">
                <base-input 
                  v-model="addition.value"
                  group class="mb-3"
                  :valid="true"
                  name="percentage"
                  :label="addition.name"
                  :disabled="!commercial.is_open"
                  append-icon="fa fa-percent" placeholder="Acréscimo"
                  mask="volume"
                />
              </div>
              <div class="row mt-5 ml-6">
                <base-radio
                  name="0"
                  :value="0"
                  v-model="newAdditions[index].operation"
                  :disabled="!commercial.is_open"
                  inline
                >
                  <strong>Somar</strong>
                </base-radio>
                <base-radio
                  name="1"
                  :value="1"
                  v-model="newAdditions[index].operation"
                  :disabled="!commercial.is_open"
                  inline
                  class="ml-4"
                >
                  <strong>Subtrair</strong>
                </base-radio>
              </div>
            </div>
          </div>
          <div class="col-md-4" >
            <base-input
              placeholder="Juros após data de pagamento"
              aria-label="Juros após data de pagamento"
              v-model="commercialBrandHandler.accrual_interest_default_value"
              group class="mb-3"
              label="Financeiro Vegetal"
              append-icon="fa fa-percent"
              mask="volume"
            />
          </div>
          <div class="col-md-4" >
            <base-input
              group class="mb-3"
              append-icon="fa fa-percent"
              v-model="commercialBrandHandler.discount_supplier_default_value"
              placeholder="Desconto do Fornecedor"
              aria-label="Desconto do Fornecedor"
              label="Desconto do Fornecedor"
              mask="volume"
            />
          </div>
          <div class="col-md-4" >
            <base-input
              group class="mb-3"
              v-model="commercialBrandHandler.vegetal_interest_default_value"
              placeholder="Juros vegetal"
              append-icon="fa fa-percent"
              label="Margem Vegetal"
              mask="volume"
            />
          </div>
          <div class="col-md-6 mb-3" >
            <label class="form-control-label">Meses para não aplicar</label>
            <multiselect
              v-model="commercialBrandHandler.unapplicable_months_default_value"
              filterable
              :options="monthBuy"
              :limit="2"
              :limitText="customLimitText"
              :multiple="true"
              :taggable="true"
              placeholder="Selecionar mês"
            />
          </div>
          <div class="col-md-6" >
            <label class="form-control-label">Meses para aplicar</label>
            <multiselect
              v-model="commercialBrandHandler.applicable_months_default_value"
              filterable
              :options="monthBuy"
              :limit="2"
              :limitText="customLimitText"
              :multiple="true"
              :taggable="true"
              placeholder="Selecionar mês"
            />
          </div>
        </div>
      </form>
    </validation-observer>

    <template slot="footer">
      <base-button type="secondary" @click="closeModalWithoutSaving">Fechar</base-button>
      <base-button type="success" @click="submit" >Salvar</base-button>
    </template>
  </modal>
</template>

<script>
import Multiselect from "@/components/Multiselect/translated_multiselect.vue";
import { DatePicker } from "element-ui";

export default {
  name: "brand-modal",
  components: {
    Multiselect,
    [DatePicker.name]: DatePicker,
  },
  props: {
    commercial: {
      type: Object,
      required: true,
    },
    commercialBrand: {
      type: Object,
      required: true,
    },
    show: {
      type: Boolean,
      required: true,
    },
    tablesErp: {
      type: Array,
      required: false,
    },
    monthBuy: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      originalValues: {},
      newAdditions: [],
      defaultAccrualInterest: null,
      defaultDiscountSupplier: null,
    }
  },
  methods: {
    customLimitText(count) {
      return `+${count}`;
    },
    closeModalWithoutSaving() {
      this.commercialBrandHandler.payment_date = this.originalValues.payment_date;
      this.commercialBrandHandler.purchase_cost_date = this.originalValues.purchase_cost_date;
      this.commercialBrandHandler.gain_margin = this.originalValues.gain_margin;
      this.commercialBrandHandler.accrual_interest_default_value = this.originalValues.accrual_interest_default_value;
      this.commercialBrandHandler.discount_supplier_default_value = this.originalValues.discount_supplier_default_value;
      this.commercialBrandHandler.vegetal_interest_default_value = this.originalValues.vegetal_interest_default_value;
      this.commercialBrandHandler.unapplicable_months_default_value = this.originalValues.unapplicable_months_default_value;
      this.commercialBrandHandler.applicable_months_default_value = this.originalValues.applicable_months_default_value;
      this.additions.forEach((addition, index) => { 
        addition.value = this.originalValues.additions[index].value;
      });
      this.newAdditions.forEach((newAddition, index) => {
        newAddition.operation = this.originalValues.newAdditions[index].operation;
      });

      this.$refs.formValidator.reset();
      this.$emit('update:show', false);
    },
    validationDayDisabledDate(time) {
      return time.getTime() < Date.parse(this.commercial.initial_date) ||
        time.getTime() > Date.parse(this.commercial.final_date)
    },
    async submit(){
      if (!await this.$refs.formValidator.validate()) return
    
      const formData = this.commercialBrandHandler

      if (this.additions.length) { 
        formData.default_additions_attributes = this.additions
        this.commercialBrand.default_additions = this.additions
      }

      this.$emit('submit', formData)
      this.$emit('update:show', false);
    },
    async getDefaultValues() {
      try {
        const response = await this.$http.secured.get("/api/v1/admin/settings")

        this.defaultAccrualInterest  = response.data.commercial_configurations.accrual_interest
        this.defaultDiscountSupplier = response.data.commercial_configurations.discount_supplier

      }
      catch(error) { console.log(error) }
    },
    setDefaultValues() {
      if (!this.commercialBrandHandler.discount_supplier_default_value) {
        this.commercialBrandHandler.discount_supplier_default_value = this.defaultDiscountSupplier;
      }

      if (!this.commercialBrandHandler.discount_supplier_default_value) {
        this.commercialBrandHandler.accrual_interest_default_value = this.defaultAccrualInterest;
      }
    },
  },
  mounted() {
    this.getDefaultValues()
  },
  watch: {
    showModal(value) {
      if (!value) return;

      this.originalValues = {
        payment_date: this.commercialBrand.payment_date,
        purchase_cost_date: this.commercialBrand.purchase_cost_date,
        gain_margin: this.commercialBrand.gain_margin,
        accrual_interest_default_value: this.commercialBrandHandler.accrual_interest_default_value,
        discount_supplier_default_value: this.commercialBrandHandler.discount_supplier_default_value,
        vegetal_interest_default_value: this.commercialBrandHandler.vegetal_interest_default_value,
        unapplicable_months_default_value: this.commercialBrandHandler.unapplicable_months_default_value,
        applicable_months_default_value: this.commercialBrandHandler.applicable_months_default_value,
        additions: this.additions.map(addition => ({ ...addition })),
        newAdditions: this.newAdditions.map(newAddition => ({ ...newAddition }))
      };

      this.setDefaultValues()      
    }
  },
  computed: {
    showModal: {
      get() {
        return this.show;
      },
      set(modal) {
        this.$emit("update:show", modal);
      },
    },
    commercialBrandHandler: {
      get() {
        return this.commercialBrand;
      },
      set(commercialBrand) {
        this.$emit("update:commercial-brand", commercialBrand);
      },
    },
    additions: {
      get() {
        let additions = this.commercialBrand.default_additions || []
        let array     = []

        // if double
        additions = additions.slice(Math.max(additions.length - this.tablesErp.length , 0))

        this.newAdditions = additions

        if (this.tablesErp.length > additions.length) array = additions;
    
        // Implementing array addition
        for (let i = 0; i < this.tablesErp.length; i++) {
          const obj = {
            name: this.tablesErp[i].desc_cta,
            value: additions[i] ? additions[i].value : "",
            id: additions[i] ? additions[i].id : null,
            tabe_cta: this.tablesErp[i].tabe_cta,
            operation: additions[i] ? additions[i].operation : null
          };
          array.push(obj);
        }

        this.newAdditions = array

        return array
      },
      set(newValue) {
        this.additions_erp = newValue
      }
    }
  },
};
</script>
